import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import './App.css';
import './fonts.css';
import './components/molecules/modals/modal.css';
import './components/template/template.css';
import './components/molecules/molecules.css';
import './components/organisms/organism.css';
import './components/atoms/buttons/Buttons.css';
import './components/atoms/formParts/formParts.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals.js';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
